import { dispatcher, api } from '@unicus/react-ui-kit';

export const LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const LOGIN_REQUEST_FINISHED = 'AUTH_LOGIN_REQUEST_FINISHED';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_REFRESH_TOKEN_FINISHED = 'AUTH_REFRESH_TOKEN_FINISHED';
export const LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REFRESH_USER = 'AUTH_UPDATE_USER';

export const AUTH_SUBSCRIPTION_CREATE = 'AUTH_SUBSCRIPTION_CREATE';
export const AUTH_SUBSCRIPTION_CREATE_FINISHED =
  'AUTH_SUBSCRIPTION_CREATE_FINISHED';

export const AUTH_SET_CURRENT_COLLABORATOR = 'AUTH_SET_CURRENT_COLLABORATOR';
export const AUTH_REMOVE_CURRENT_COLLABORATOR =
  'AUTH_REMOVE_CURRENT_COLLABORATOR';

const onAuthSuccess = (data) => {
  if (data && data.user) {
    const expirationDate = new Date();
    expirationDate.setSeconds(
      expirationDate.getSeconds() + data.expireInSeconds
    );

    if (data.tenantId) {
      localStorage.setItem('tenantId', data.tenantId);
    } else {
      localStorage.removeItem('tenantId');
    }
    localStorage.setItem(
      'auth_data',
      btoa(JSON.stringify({ ...data, expirationDate }))
    );
    localStorage.setItem('auth_accesstoken', data.accessToken);
    localStorage.setItem('auth_refreshtoken', data.refreshToken);
  }
};

export const createAccount = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'auth',
    actionType: LOGIN_REQUEST,
    effect: async () => api.post('auth', params),
    onSuccess: ({ data }) => {
      onAuthSuccess(data);
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};

export const createSubscription = (params, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'auth',
    actionType: AUTH_SUBSCRIPTION_CREATE,
    effect: async () => api.post('subscriptions', params),
    onSuccess,
    onFail
  });
};

export const changeTenant = (tenantId, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'auth',
    actionType: LOGIN_REQUEST,
    effect: async () => api.post(`auth/change-tenant`, { tenantId }),
    onSuccess: ({ data }) => {
      onAuthSuccess(data);
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};

export const refreshToken = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'auth',
    actionType: LOGIN_REQUEST,
    effect: async () => api.post('/auth/refresh-token', params),
    onSuccess: ({ data }) => {
      onAuthSuccess(data);

      if (onSuccess) {
        onSuccess();
      }
    }
  });
};

export const setCurrentCollaborator = (collaborator) => (dispatch) => {
  localStorage.setItem('current_collaborator', JSON.stringify(collaborator));

  dispatch(
    dispatcher.createAction(AUTH_SET_CURRENT_COLLABORATOR, 'auth', collaborator)
  );
};

export const removeCurrentCollaborator = () => (dispatch) => {
  localStorage.removeItem('current_collaborator');
  dispatch(dispatcher.createAction(AUTH_REMOVE_CURRENT_COLLABORATOR, 'auth'));
};

export const changeCompany = (companyId, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'auth',
    actionType: LOGIN_REQUEST,
    effect: async () => api.post(`auth/change-company`, { companyId }),
    onSuccess: ({ data }) => {
      onAuthSuccess(data);
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};
